<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 15 75 75"
    width="100%"
    height="100%"
    preserveAspectRatio="none"
  >
    <g
      transform="translate(0,110) scale(0.1,-0.1)"
      fill="currentColor"
      stroke="none"
    >
      <path
        d="M292 825 c-56 -25 -107 -71 -138 -127 -25 -46 -29 -63 -29 -133 0
        -90 20 -139 79 -198 49 -49 101 -71 182 -75 56 -3 81 0 116 16 108 47 168 139
        168 256 0 118 -57 209 -160 255 -54 25 -168 28 -218 6z m226 -62 c28 -17 59
        -48 77 -77 26 -43 30 -59 30 -120 0 -59 -5 -79 -27 -117 -121 -206 -432 -119
        -430 122 0 93 63 182 153 216 54 20 143 10 197 -24z"
      />
      <path
        d="M325 743 c-40 -21 -84 -62 -101 -95 -19 -37 -18 -129 3 -173 16 -34
        33 -46 33 -24 0 5 25 74 55 152 30 78 55 145 55 149 0 11 -11 9 -45 -9z m-49
        -127 c-8 -20 -18 -36 -22 -36 -9 0 5 52 18 68 18 21 20 6 4 -32z"
      />
      <path
        d="M425 744 c4 -11 31 -81 60 -157 28 -75 55 -140 58 -143 14 -14 41 65
        42 122 0 49 -5 68 -27 101 -27 40 -72 74 -117 88 -21 6 -23 5 -16 -11z"
      />
      <path
        d="M340 549 c-58 -155 -59 -149 15 -170 41 -12 114 0 141 22 8 7 -2 45
        -41 144 -28 74 -54 137 -56 140 -3 3 -29 -59 -59 -136z m90 -50 c23 -61 23
        -62 4 -76 -19 -14 -70 -11 -87 6 -10 10 42 143 53 136 4 -2 18 -32 30 -66z"
      />
    </g>
  </svg>
</template>
